module.exports = __webpack_public_path__ + "img/payment_pc_01.9def53c2.png";